module.exports = __webpack_public_path__ + "img/rank_icon_5.fae927c5.png";